import { UserConfig } from "../types/configHandler.types";
import { ANY_ORIGIN } from "../constants";

export function getDefaultConfig(): UserConfig {
    return {
        targetOrigin: ANY_ORIGIN,
        targetWindow: {
            postMessage: () => {},
        } as unknown as Window,
        debug: false,
        channelId: "",
        suppressErrors: false,
    };
}
